const HTTP_PROTOCOLS = new Set(["http:", "https:"]);
const SOCKET_PROTOCOLS = new Set(["ws:", "wss:"]);

export function getDashboardApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_API_DOMAIN;
  if (!configuredUrl) return null;

  try {
    const url = new URL(configuredUrl);
    return HTTP_PROTOCOLS.has(url.protocol) ? url.origin : null;
  } catch {
    return null;
  }
}

export function getLiveChatWsBaseUrl() {
  const configuredUrl = process.env.REACT_APP_LIVE_CHAT_WS_DOMAIN;
  if (!configuredUrl) return null;

  try {
    const url = new URL(configuredUrl);
    return HTTP_PROTOCOLS.has(url.protocol) || SOCKET_PROTOCOLS.has(url.protocol)
      ? url.origin
      : null;
  } catch {
    return null;
  }
}

export function resolveApiUrl(value, baseUrl = getDashboardApiBaseUrl()) {
  if (!value || !baseUrl) throw new Error("Live chat API URL is unavailable");
  const resolved = new URL(value, `${baseUrl}/`);
  if (!HTTP_PROTOCOLS.has(resolved.protocol)) {
    throw new Error("Unsupported live chat API URL");
  }
  return resolved.toString();
}

export function resolveSocketUrl(
  value,
  baseUrl = getDashboardApiBaseUrl(),
  wsBaseUrl = getLiveChatWsBaseUrl()
) {
  const configuredBaseUrl = wsBaseUrl || baseUrl;
  if (!value || !configuredBaseUrl) {
    throw new Error("Live chat socket URL is unavailable");
  }

  const socketBase = new URL(configuredBaseUrl);
  if (socketBase.protocol === "https:") socketBase.protocol = "wss:";
  if (socketBase.protocol === "http:") socketBase.protocol = "ws:";
  const resolved = new URL(value, socketBase);
  if (HTTP_PROTOCOLS.has(resolved.protocol)) {
    resolved.protocol = resolved.protocol === "https:" ? "wss:" : "ws:";
  }
  if (!SOCKET_PROTOCOLS.has(resolved.protocol)) {
    throw new Error("Unsupported live chat socket URL");
  }
  return resolved.toString();
}

export function getTrustedParentOrigins({ domain, preview }) {
  const origins = new Set();
  const apiBaseUrl = getDashboardApiBaseUrl();
  if (apiBaseUrl) origins.add(apiBaseUrl);

  if (!preview && domain) {
    try {
      origins.add(new URL(`https://${domain}`).origin);
    } catch {
      // Invalid external input is intentionally ignored.
    }
  }

  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(window.location.origin)) {
    origins.add(window.location.origin);
  }
  return origins;
}
